export default function penniesToDollars(pennies: number): string {
  if (typeof pennies !== "number") {
    throw new TypeError("pennies must be a number");
  }

  if (pennies < 0) {
    return `-$${(-pennies / 100).toFixed(2)}`;
  }

  return `$${(pennies / 100).toFixed(2)}`;
}
